import type { Translations } from './messages';

export const ar: Translations = {
  'nav.home': 'الرئيسية',
  'nav.expertise': 'خبراتنا',
  'nav.engagement': 'نماذج التعاقد',
  'nav.caseStudies': 'قصص النجاح',
  'nav.itServices': 'خدمات التقنية',
  'nav.blog': 'المدونة',
  'nav.contact': 'اتصل بنا',
  'nav.solutions': 'حلولنا',
  'nav.dashboard': 'لوحة التحكم',
  'nav.logout': 'تسجيل الخروج',
  'nav.signIn': 'تسجيل دخول',
  'nav.signUp': 'حلول VYE',
  
  'hero.eyebrow': 'VYE — شريكك الاستراتيجي للابتكار والتحول الرقمي في مصر',
  'hero.eyebrowEn': 'VYE — Your Strategic Partner for Digital Transformation & Advanced IT Solutions in Egypt',
  'hero.badge': 'VYE Next-Gen Technology Solutions',
  'hero.title': 'شركاء نجاح الشركات التقنية الناشئة في مصر:',
  'hero.titleHighlight': 'تطوير تطبيقات جوال قابلة للتوسع',
  'hero.description': 'نحن نتعاون مع الشركات التقنية الناشئة في مصر لتصميم وبناء تطبيقات جوال قابلة للتوسع وتركز على المستخدم لتسريع عجلة النمو.',
  'hero.ctaPrimary': 'ابدأ مشروعك الآن',
  'hero.ctaSecondary': 'تصفح أعمالنا',
  
  'flagship.title': 'من نحن — خبرة تقنية عميقة وفهم للسوق المصري',
  'flagship.description': 'تأسست VYE لتقديم حلول تقنية متكاملة للشركات في مصر، بدءًا من الشركات الناشئة وحتى المؤسسات الكبرى. نحن فريق من المهندسين، المطورين، وخبراء الأمن السيبراني الذين يجمعون بين الخبرة العالمية والفهم الدقيق لبيئة الأعمال المصرية، مع الالتزام الكامل بتقديم نتائج ملموسة.',
  'flagship.cardTitle': 'منصة متجر السحابية',
  'flagship.cardDesc': 'الحل المتكامل لإدارة وإنشاء المتاجر الإلكترونية في السوق المصري.',
  'flagship.cardEn': 'Integrated e-commerce and automation for merchants.',
  'flagship.cardCta': 'إطلاق متجرك عبر منصة متجر',
  
  'features.eyebrow': 'رؤيتنا — تمكين الشركات المصرية من بناء مستقبل رقمي أقوى',
  'features.eyebrowEn': 'Our Vision — Empowering Businesses to Build a Stronger Digital Future',
  'features.badge': 'رؤيتنا وقدراتنا التقنية',
  'features.title': 'تمكين الشركات من بناء مستقبل رقمي أقوى',
  'features.description': 'نحن نؤمن أن التكنولوجيا ليست رفاهية، بل ضرورة استراتيجية. هدفنا هو مساعدة الشركات على تحسين الأداء التشغيلي، تقليل التكاليف، تعزيز الأمان، رفع الإنتاجية، ودعم اتخاذ القرار عبر بناء بنية تحتية قابلة للتوسع.',
  'features.c1.title': 'التحول الرقمي',
  'features.c1.desc': 'نساعدك على تحويل عملياتك التقليدية إلى أنظمة رقمية ذكية من خلال تحليل الوضع الحالي وتصميم خطة تحول شاملة.',
  'features.c2.title': 'أتمتة الأعمال (Business Automation)',
  'features.c2.desc': 'نقوم بتطوير حلول أتمتة تشمل إدارة سير العمل، والموارد البشرية، والفواتير، والمحاسبة لتقليل الأخطاء وزيادة الإنتاجية.',
  'features.c3.title': 'خدمات Cloud و Cybersecurity',
  'features.c3.desc': 'نقدم حلولاً سحابية (Cloud) آمنة لحماية البيانات، ومراقبة التهديدات، واختبار الاختراق، وتقييم الثغرات الأمنية.',
  'features.c4.title': 'تطوير البرمجيات (Custom Software)',
  'features.c4.desc': 'تطوير تطبيقات الويب، ومنصات التجارة الإلكترونية، وأنظمة ERP المخصصة بالكامل لتناسب متطلبات أعمالك.',
  'features.cta.title': 'هل أنت جاهز للبدء؟',
  'features.cta.desc': 'تواصل مع فريق VYE اليوم واحجز استشارة مجانية لمعرفة كيف يمكننا تحويل أعمالك.',
  'features.cta.btn': 'احجز استشارة مجانية',
  'pricing.cta.title': 'جاهز لبدء شراكة استراتيجية؟',
  'pricing.cta.desc': 'اختر النموذج الأنسب لأعمالك وتواصل مع خبرائنا للحصول على خطة مخصصة.',
  'pricing.cta.btn': 'تواصل معنا اليوم',
  'scrollyTitle': 'خدماتنا الجيل الجديد',
  'scrollySubtitle': 'نُمكّن الشركات بتقنيات متقدمة واستراتيجيات رقمية مبتكرة.',
  'scrolly_f1_title': 'منصة متجر السحابية',
  'scrolly_f1_desc': 'حل تجارة إلكترونية شامل صُمم خصيصاً للسوق المصري، مع أتمتة كاملة وبوابات دفع وربط شركات الشحن.',
  'scrolly_f2_title': 'بنية Hybrid Cloud',
  'scrolly_f2_desc': 'تصميم ونشر أنظمة Cloud مرنة وقابلة للتوسع تضمن استمرارية العمل مع تحسين التكلفة الإجمالية للملكية.',
  'scrolly_f3_title': 'أمن سيبراني (Cybersecurity)',
  'scrolly_f3_desc': 'آليات دفاع استباقية على مدار الساعة وتحليل للتهديدات لحماية الأصول الحيوية لشركتك من الهجمات المتقدمة.',
  'scrolly_f4_title': 'هندسة برمجيات (Software Engineering)',
  'scrolly_f4_desc': 'تطبيقات ويب وموبايل عالية الأداء، مبنية خصيصاً لتناسب عملياتك وتقدم تجربة رقمية عالمية المستوى.',
  
  'pricing.eyebrow': 'شراكة تقنية متكاملة لنجاح مستدام',
  'pricing.eyebrowEn': 'Strategic engagement models for sustainable scale',
  'pricing.badge': 'نماذج التعاقد والعمل',
  'pricing.title': 'شراكة استراتيجية لنمو متسارع',
  'pricing.description': 'نقدم نماذج مرنة لتقديم الخدمات التقنية بما يتناسب مع حجم أعمالك وأهدافك التجارية.',
  'pricing.c1.title': 'شراكة المشاريع الكاملة',
  'pricing.c1.desc': 'نتولى دور الشريك التكنولوجي من التخطيط والتصميم وحتى البرمجة والإطلاق كحل متكامل.',
  'pricing.c2.title': 'فرق التطوير المخصصة',
  'pricing.c2.desc': 'نوفر مهندسين وخبراء تقنيين للانضمام إلى فريقك وتسريع وتيرة العمل وتطوير المزايا.',
  'pricing.c3.title': 'المنتجات الجاهزة (SaaS)',
  'pricing.c3.desc': 'نطور منصات سحابية مبتكرة جاهزة لخدمة القطاعات، مثل منصتنا الرائدة متجر.',
  
  'it.badge': 'خدمات وحلول تقنية معلومات للشركات',
  'it.title': 'خدماتنا بالتفصيل — حلول تقنية متكاملة:',
  'it.titleHighlight': 'Enterprise IT & Business Technology Solutions',
  'it.description': 'نحن نقدم باقة واسعة من الحلول التقنية للأعمال لمساعدتك على التفوق. سواء كنت شركة ناشئة أو مؤسسة كبيرة، فإن خبرتنا في مجال خدمات تقنية المعلومات في مصر تضمن لك الحصول على الدعم الذي تحتاجه. خدماتنا مصممة لتكون قابلة للتطوير وفعالة من حيث التكلفة، مما يضمن تحقيق أقصى عائد على استثمارك التكنولوجي.',
  'it.subtitle': 'خدمات تقنية متكاملة للشركات الحديثة',
  'it.subdescription': 'بصفتنا مزوداً رائداً للتقنيات الحديثة، نتخصص في صياغة استراتيجيات تتوافق تماماً مع احتياجاتك التشغيلية لحل التحديات المعقدة.',
  'it.coreTitle': 'عروض خدماتنا الأساسية',
  'it.c1.title': 'التحول الرقمي',
  'it.c1.desc': 'نساعدك على تحويل عملياتك التقليدية إلى أنظمة رقمية ذكية لرفع كفاءة وسرعة أعمالك.',
  'it.c2.title': 'أتمتة الأعمال (Business Automation)',
  'it.c2.desc': 'تطوير حلول أتمتة تشمل المحاسبة، خدمة العملاء، والمشاريع، لخفض التكاليف وزيادة الإنتاجية.',
  'it.c3.title': 'خدمات Cloud و Cybersecurity',
  'it.c3.desc': 'خدمات ترحيل البيانات وحماية الأنظمة واختبارات الاختراق وإدارة الهويات.',
  'it.c4.title': 'تطوير البرمجيات (Custom Software)',
  'it.c4.desc': 'تطوير تطبيقات الويب، الهواتف الذكية، وأنظمة ERP المخصصة بالكامل لتناسب متطلبات أعمالك.',
  'it.c5.title': 'الدعم التقني للشركات',
  'it.c5.desc': 'دعم فني استباقي على مدار الساعة لمراقبة الأنظمة، حل الأعطال، وإدارة الخوادم والشبكات.',
  
  'it.partnerTitle': 'لماذا تختار VYE؟',
  'it.partnerDesc': 'نحن نتميز بالخبرة التقنية العميقة، والفهم الدقيق لمتطلبات الأعمال في السوق المصري، ونقدم حلولاً قابلة للتطوير مع دعم فني 24/7 وتنفيذ سريع يقدم نتائج ملموسة تدعم شراكتنا الاستراتيجية طويلة المدى.',
  'it.partnerCta': 'تواصل معنا اليوم',
  
  'contact.eyebrow': 'ابدأ رحلة التحول الرقمي الآن',
  'contact.eyebrowEn': 'Reach out and let our experts bring your vision to life',
  'contact.title': 'اتصل بنا',
  'contact.description': 'نحن هنا لمساعدتك في أي استفسار. تواصل معنا وسيقوم فريق الدعم بالرد عليك في أقرب وقت.',
  'contact.nameLabel': 'الاسم الكامل',
  'contact.namePlaceholder': 'أحمد محمد',
  'contact.emailLabel': 'البريد الإلكتروني',
  'contact.emailPlaceholder': 'name@domain.com',
  'contact.subjectLabel': 'عنوان الاستفسار',
  'contact.subjectPlaceholder': 'استفسار عن خدمات باقة الأعمال',
  'contact.messageLabel': 'نص الرسالة',
  'contact.messagePlaceholder': 'اكتب تفاصيل استفسارك هنا...',
  'contact.submit': 'إرسال الرسالة',
  'contact.successMsg': 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.',
  'contact.infoTitle': 'تواصل معنا مباشرة',
  'contact.phone': '+20 100 123 4567',
  'contact.phoneLabel': 'هاتف',
  'contact.whatsapp': 'https://wa.me/201001234567',
  'contact.whatsappLabel': 'واتساب',
  'contact.email': 'contact@vye.onl',
  'contact.emailContactLabel': 'البريد الإلكتروني',
  'contact.address': 'مبنى الجريك كامبس، ٢٨ شارع الفلكي، باب اللوق، القاهرة، مصر',
  'contact.addressLabel': 'العنوان',
  
  'seo.eyebrow': 'خبرة تقنية عميقة وفهم للسوق المصري',
  'seo.title': 'التحول الرقمي وأتمتة الأعمال للشركات الرائدة في مصر',
  'seo.description': 'نستهدف النجاح المستدام من خلال تحديث البنية التحتية لتكنولوجيا المعلومات (IT Infrastructure)، وتحسين إجراءات العمل، وتقديم حلول Hybrid Cloud متطورة تساعدك في الريادة وتصدر النتائج.',
  'seo.c1.title': 'التحول الرقمي (Digital Transformation)',
  'seo.c1.desc': 'نقل عملياتك التقليدية بسلاسة وبأمان تام إلى أنظمة رقمية ذكية.',
  'seo.c2.title': 'أتمتة الأعمال وأنظمة Cloud',
  'seo.c2.desc': 'أنظمة Hybrid Cloud وخدمات أتمتة شاملة للموارد البشرية والمحاسبة وإدارة المشاريع.',
  'seo.c3.title': 'تطوير برمجيات مخصصة (Outsourcing)',
  'seo.c3.desc': 'تطوير تطبيقات ويب، أنظمة ERP، وتطبيقات هواتف ذكية بأعلى درجات الكفاءة.',
 
  'faq.eyebrow': 'الأسئلة الشائعة',
  'faq.title': 'إجابات على استفساراتك التقنية',
  'faq.description': 'تعرف على كيف يمكن لـ VYE تسريع التحول الرقمي لأعمالك في مصر.',
  'faq.q1': 'ما هي الحوسبة السحابية وكيف تستفيد منها شركتي في مصر؟',
  'faq.a1': 'توفر الحوسبة السحابية وصولاً مرناً وقابلاً للتطوير إلى الموارد التقنية عبر الإنترنت. إنها تساعد الشركات المصرية على تقليل تكاليف تكنولوجيا المعلومات، وتحسين تعاون فرق العمل، وضمان الوصول الآمن للبيانات من أي مكان.',
  'faq.q2': 'كيف يمكنني حماية شركتي من التهديدات السيبرانية في مصر؟',
  'faq.a2': 'ننفذ خدمات أمن سيبراني قوية تشمل اكتشاف التهديدات المُدارة، والنسخ الاحتياطي الآمن للبيانات، واستردادها، وحلول أمن الشبكات الشاملة لحماية أصولك الرقمية من التهديدات المتطورة.',
  'faq.q3': 'ما هي أنواع البرمجيات التي تطورها VYE؟',
  'faq.a3': 'نقدم خدمات تطوير البرمجيات المخصصة في مصر، متخصصون في منصات SaaS للشركات، وتطبيقات الويب والهواتف المحمولة القابلة للتطوير، وتكامل الأنظمة المعقدة المصممة لتحسين عمليات الأعمال.',
  'faq.q4': 'ما هي خدمات تكنولوجيا المعلومات المُدارة وماذا تشمل؟',
  'faq.a4': 'توفر خدمات تكنولوجيا المعلومات المُدارة لدينا دعماً تقنياً استباقياً للشركات في مصر. نحن نتولى تحديث البنية التحتية، ومراقبة الأنظمة على مدار الساعة، وإدارة السحابة، والاستشارات التقنية الاستراتيجية لتتمكن من التركيز على نمو أعمالك الأساسية.',
 
  'footer.rights': 'جميع الحقوق محفوظة.',
  
  'blog.eyebrow': 'المدونة التقنية',
  'blog.title': 'أحدث المقالات والرؤى',
  'blog.description': 'استكشف أحدث التوجهات التقنية، ونصائح التحول الرقمي، ودراسات مقارنة حول الحلول السحابية و SaaS في السوق المصري.',
  
  'solutions.eyebrow': 'منصاتنا وحلولنا البرمجية المبتكرة',
  'solutions.eyebrowEn': 'Our Innovative Platforms & Software Solutions',
  'solutions.badge': 'حلول VYE البرمجية',
  'solutions.title': 'حلول برمجية متكاملة لتمكين أعمالك وتجارتك',
  'solutions.description': 'نطور ونشغل منصات رقمية جاهزة مصممة خصيصاً لتمكين الشركات والتجار من تحقيق الريادة والنمو المتسارع.',
  'solutions.matjaar.title': 'منصة متجر السحابية (Matjaar Cloud)',
  'solutions.matjaar.desc': 'الحل المتكامل لإدارة وإنشاء المتاجر الإلكترونية المخصصة في السوق المصري. أنشئ متجرك وأدر عمليات الدفع والشحن والتحليلات الذكية من مكان واحد وبأداء فائق السرعة وبأمان عالٍ.',
  'solutions.matjaar.badge': 'متاح الآن',
  'solutions.matjaar.feature1': 'واجهة برمجية للمتاجر',
  'solutions.matjaar.feature2': 'بوابات دفع محلية',
  'solutions.matjaar.feature3': 'مزامنة المخزون',
  'solutions.matjaar.cta': 'اكتشف منصة متجر',
  'solutions.comingsoon.title': 'VYE Enterprise Hub',
  'solutions.comingsoon.desc': 'قريباً — نعمل على بناء منصة مؤسسية متكاملة تشمل إدارة الموارد البشرية، المحاسبة، وأتمتة الأعمال، مصممة خصيصاً للشركات المصرية المتنامية.',
  'solutions.comingsoon.badge': 'قريباً',
  'trust.heading': 'موثوق به من قِبَل شركات مصر الرائدة',
  'trust.headingEn': 'Trusted by Leading Egyptian Businesses',
  'testimonials.badge': 'آراء عملائنا',
  'testimonials.title': 'ماذا يقول شركاؤنا',
  'footer.newsletter': 'اشترك في نشرتنا التقنية',
  'footer.newsletterPlaceholder': 'بريدك الإلكتروني',
  'footer.newsletterCta': 'اشتراك'
};
